import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import { getAppVersion, isIos } from "@/utils/lodash";
import Http from "@/api/http/fetch/index";
import { judgeVersion } from "@/utils/judgeVersion";
import generalUtilsHelper from "@/utils/generalUtils";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY
} from "@/utils/superPayAndBackUp";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
const actions: ActionTree<any, any> = {
  async [types.CHECK_BACK_UP_APP_CAN_SHOW](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //判断是否可用于显示app：
    try {
      //判断原生请求superpay的接口是否可用
      const checkConfigEnable = await dispatch(
        types.CHECK_BACK_UP_APP_CONFIG_ENABLE
      );
      console.log("checkConfigEnable:", checkConfigEnable);
      if (checkConfigEnable) {
        //拉取更新配置：
        const superPayAppConfig = await dispatch(
          types.REQUEST_BACK_UP_APP_CONFIG
        );
        //检查是否安装了app:
        const checkSuperPayAppInstalled = await dispatch(
          types.CHECK_BACK_UP_APP_INSTALLED,
          superPayAppConfig
        );
        if (checkSuperPayAppInstalled) {
          commit(types.UPDATE_BACK_UP_APP_SHOW_ENABLE, false);
          return false; //如果已经装了
        } else {
          //最后判断是否在setting有配字段：
          //判断是否有super_pay的字段,加上了部分前置条件
          if (
            getters[types.GETTER_BACK_UP_APP_SETTING_PARAMS_VALID] &&
            getters[types.GETTER_BACK_UP_APP_SHOW_OTHER_CONDITION]()
          ) {
            // dispatch(types.SHOW_SUPER_PAY_BUBBLE);TODO
            commit(types.UPDATE_BACK_UP_APP_SHOW_ENABLE, true);
            return true;
          } else {
            commit(types.UPDATE_BACK_UP_APP_SHOW_ENABLE, false);
            return false;
          }
        }
      } else {
        return false;
      }
    } catch (error) {
      console.log("CHECK_BACK_UP_APP_CAN_SHOW error:", error);
      return false;
    }
  },
  async [types.CHECK_BACK_UP_PAY_WAY_CAN_USE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //判断是否可用于显示app：
    try {
      const appInfo: any = await Http.AppInfo();
      const userAgent = getAppVersion();
      console.log("userAgent", userAgent);
      let versionNew: any = false;
      if (isIos()) {
        versionNew =
          appInfo &&
          appInfo.CODE_VERSION &&
          judgeVersion(appInfo.CODE_VERSION, "4.4.0");
      } else {
        versionNew = judgeVersion(userAgent, "4.4.0");
      }
      commit(types.UPDATE_BACK_UP_APP_PAY_WAY_INTERFACE_ENABLE, versionNew);
      if (versionNew) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  async [types.SWITCH_FRONT_BACK_TO_CHECK_BACK_UP_INSTALL_STATUS](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const checkBackUpAppInstallProcess = async () => {
      const checkSuperPayAppInstalledResult = await dispatch(
        types.CHECK_BACK_UP_APP_INSTALLED,
        getters[types.GETTER_BACK_UP_APP_CONFIG]
      );
      if (checkSuperPayAppInstalledResult) {
        //如果安装了
        commit(types.UPDATE_BACK_UP_APP_SHOW_ENABLE, false); //隐藏推荐
        //从feed中替换super feed：
        commit(types.REPLACE_BACK_UP_OFFER_FEED);
      } else {
        //如果没有安装，再次显示: ，如果没有达到其他的必要条件 不能显示
        if (
          getters[types.GETTER_BACK_UP_APP_SETTING_PARAMS_VALID] &&
          getters[types.GETTER_BACK_UP_APP_SHOW_OTHER_CONDITION]()
        ) {
          commit(types.UPDATE_BACK_UP_APP_SHOW_ENABLE, true); //再次显示
        }
        //再次拉取appCoinfig:
        dispatch(types.REQUEST_BACK_UP_APP_CONFIG);
      }
    };

    if (getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
      //如果显示中:
      checkBackUpAppInstallProcess();
    } else {
      //如果没有显示,检查是否拉到了superPayAppCoinfig
      if (getters[types.GETTER_BACK_UP_APP_CONFIG]) {
        checkBackUpAppInstallProcess();
      }
    }
  },
  async [types.SHOW_SUPER_PAY_BUBBLE](
    { state, commit, dispatch, getters },
    payload: any
  ) {},
  async [types.START_INSTALL_BACK_UP_APP](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      // 如果当前app已下架， 调用转移接口
      const appTakeDown = getters[types.GETTER_APP_TAKE_DOWN];
      if (appTakeDown) {
        dispatch(types.TRANSFER_MASTER_ID_TO_IDFA);
      }

      const superPayAppConfig = getters[types.GETTER_BACK_UP_APP_CONFIG];
      const superPayParams = getters[types.GETTER_BACK_UP_APP_PARAMS];

      Http.ADConnect(); //安卓说要频繁调用

      const rewardProcess = () => {
        const newConfig =
          !isIos() && judgeVersion(getAppVersion(), "4.9.0")
            ? {
                ...superPayAppConfig,
                isSuperPay: true,
                isPure: false
              }
            : superPayAppConfig;
        console.log("superPayAppConfig===>", newConfig);
        Http.ADStart(newConfig).then((result: any) => {
          console.log("ADStart result:", result);
        });
      };

      const noRewardProcess = () => {
        Http.StartNewWebInstance(superPayAppConfig.downloadUrl);
      };

      if (payload.type === "static") {
        //固定UI
        if (
          generalUtilsHelper.isLoginUser() &&
          !getters[types.GETTER_BACK_UP_APP_HAS_INSTALLED]
        ) {
          rewardProcess();
        } else {
          noRewardProcess();
        }
      } else {
        //弹窗类型:
        if (
          superPayParams.launch_reward_enabled &&
          !getters[types.GETTER_BACK_UP_APP_HAS_INSTALLED] &&
          generalUtilsHelper.isLoginUser()
        ) {
          rewardProcess();
        } else {
          noRewardProcess();
        }
      }

      //点击打点
      if (payload && payload.ga) {
        sendEventWithParams("uia_recommend_app_click", {
          back_up: payload.ga
        });

        //存储ga变量
        SuperPayAndBackUpHelpers.setLocalKeyTimes(
          LOCAL_KEY.BACK_UP_INSTALL_TMEP_KEY,
          payload.ga
        );
      }
    } catch (error) {}
  },
  async [types.REQUEST_BACK_UP_APP_CONFIG](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      let superPayAppConfigResult: any = null;
      const superPayAppConfig: any = await Http.BackUpSuperPayAppConfig();
      console.log("获取到backupAppConfig:", superPayAppConfig);

      if (superPayAppConfig.status && superPayAppConfig.status === "fail") {
        commit(types.UPDATE_BACK_UP_APP_SHOW_ENABLE, false);
        return Promise.reject(superPayAppConfig.error);
      } else {
        if (isIos()) {
          superPayAppConfigResult = superPayAppConfig;
        } else {
          superPayAppConfigResult = superPayAppConfig.data;
          if (
            judgeVersion(getAppVersion(), "4.9.0") &&
            superPayAppConfigResult
          ) {
            superPayAppConfigResult = Base64.parse(
              superPayAppConfigResult
            ).toString(Utf8);
            superPayAppConfigResult = JSON.parse(superPayAppConfigResult);
          }
        }
        console.log("parse backupAppConfig:", superPayAppConfigResult);

        commit(types.UPDATE_BACK_UP_APP_CONFIG, superPayAppConfigResult);
        return superPayAppConfigResult;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.CHECK_BACK_UP_APP_INSTALLED](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const installed = await dispatch(
        types.REQUEST_APP_STATE,
        payload.packageName
      );
      console.log("back up installed：", installed);
      //打点：
      if (installed) {
        if (!getters[types.GETTER_BACK_UP_APP_INSTALLED_STATUS]) {
          //如果从未安装到安装，进行打点：
          const ga = SuperPayAndBackUpHelpers.getLocalKeyTimes(
            LOCAL_KEY.BACK_UP_INSTALL_TMEP_KEY
          );
          sendEventWithParams("uia_recommend_app_installed", {
            back_up: ga
          });
        }
      }

      commit(types.UPDATE_BACK_UP_APP_INSTALLED_STATUS, installed);

      return installed;
    } catch (error) {
      return true; //让其不显示
    }
  },
  async [types.CHECK_BACK_UP_APP_CONFIG_ENABLE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //判断是否可用于显示app：
    try {
      const appInfo: any = await Http.AppInfo();
      const userAgent = getAppVersion();
      console.log("userAgent", userAgent);
      let versionNew: any = false;
      if (isIos()) {
        versionNew =
          appInfo &&
          appInfo.CODE_VERSION &&
          judgeVersion(appInfo.CODE_VERSION, "4.4.0");
      } else {
        versionNew = judgeVersion(userAgent, "4.4.0");
      }
      commit(types.UPDATE_BACK_UP_APP_CONFIG_INTERFACE_ENABLE, versionNew);
      if (versionNew) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }
};

export default actions;
